import React, { useState } from 'react';
import { Popper } from '@mui/base/Popper';
import styles from './user-info-popper.module.css';
import { Card, Fade } from '@otp/ui';
import { Issue } from '@otp/icons';
import { useTranslation } from 'react-i18next';

export const UserInfoPopper = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'user-info-popper' : undefined;

  return (
    <div>
      <div className={styles.wrapper} onClick={handleClick}>
        <Issue style={{ background: 'none' }} />
        {t('most.list.filter.user')}
      </div>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="top-end"
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              <Card className={styles.cardWrapper}>
                {t('most.list.filter.user-description')}
              </Card>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export default UserInfoPopper;
